<template>
  <b-modal
    id="modal-detail-penerbitanditerimapenilaianteknis"
    title="Penilaian Teknis Diterima"
    size="xl"
    body-class="bg-white"
    @close="closeModal"
    @hide="closeModal"
  >
    <template>
      <div class="mb-4">
        <button
          type="button"
          :class="{
            'btn btn-outline-secondary': true,
            active: tipePermohonan === 'Berusaha',
          }"
          @click="changeTipePermohonan('Berusaha')"
        >
          Berusaha
        </button>
        <button
          type="button"
          :class="{
            'btn btn-outline-secondary ms-2': true,
            active: tipePermohonan === 'Nonberusaha',
          }"
          @click="changeTipePermohonan('Nonberusaha')"
        >
          Nonberusaha
        </button>
      </div>

      <PermohonanBerusaha
        v-if="tipePermohonan === 'Berusaha'"
        :filter-tahun="filterTahun"
      />
      <PermohonanNonberusaha
        v-if="tipePermohonan === 'Nonberusaha'"
        :filter-tahun="filterTahun"
      />
    </template>
    <template #modal-footer>
      <div class="w-100">
        <b-button
          variant="primary"
          size="sm"
          class="float-right"
          @click="closeModal"
        >
          Tutup
        </b-button>
      </div>
    </template>
  </b-modal>
</template>

<script>
import PermohonanBerusaha from './PermohonanBerusaha.vue'
import PermohonanNonberusaha from './PermohonanNonberusaha.vue'

export default {
  components: { PermohonanBerusaha, PermohonanNonberusaha },
  props: ['show', 'filterTahun'],
  emits: ['close'],
  data() {
    return {
      baseapi: localStorage.getItem('baseapi'),
      user: JSON.parse(localStorage.getItem('user')),
      tipePermohonan: 'Berusaha',
    }
  },
  methods: {
    closeModal() {
      this.$emit('close', false)
    },

    changeTipePermohonan(tipe) {
      this.tipePermohonan = tipe
    },
  },
  watch: {
    show: {
      handler(val) {
        if (val) {
          this.$bvModal.show('modal-detail-penerbitanditerimapenilaianteknis')
        } else {
          this.$bvModal.hide('modal-detail-penerbitanditerimapenilaianteknis')
        }
      },
    },
  },
}
</script>
